/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Walkthrough_User_Api_Keys_DescriptionInputs */

const es_walkthrough_user_api_keys_description = /** @type {(inputs: Walkthrough_User_Api_Keys_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generá y administrá tu clave API personal para integraciones externas. Guardala bien — solo podés ver la clave una vez. Más abajo encontrás la Zona de Peligro donde podés eliminar tu cuenta.`)
};

const en_walkthrough_user_api_keys_description = /** @type {(inputs: Walkthrough_User_Api_Keys_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate and manage your personal API key for external integrations. Keep it safe — you can only see the key once. Below you'll find the Danger Zone where you can delete your account.`)
};

/**
* | output |
* | --- |
* | "Generate and manage your personal API key for external integrations. Keep it safe — you can only see the key once. Below you'll find the Danger Zone where yo..." |
*
* @param {Walkthrough_User_Api_Keys_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const walkthrough_user_api_keys_description = /** @type {((inputs?: Walkthrough_User_Api_Keys_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Walkthrough_User_Api_Keys_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_walkthrough_user_api_keys_description(inputs)
	return en_walkthrough_user_api_keys_description(inputs)
});
export { walkthrough_user_api_keys_description as "walkthrough.user_api_keys_description" }